<template>
  <div class="top-block">
    <div style="width: 99%; height:60px;display: inline-block">
      <i
        class="el-icon-back ret"
        @click="goBack"
        style="position: relative;left: 15px;"
      ></i>
      <i class="blue-border"></i>
      <p class="top-tit">{{ Title }}历史作业位置</p>
    </div>
    <div class="side" v-if="side">
      <div class="hiden">
        <div
          v-for="(item, inx) in tableData"
          :key="inx"
          style="display: inline-block;font-size: 16px;margin-left: 20px"
        >
          <p style="font-size: 16px;color: #ffffff;margin-bottom: 8px;">
            {{ item.year }}
          </p>
          <el-timeline style="color: #ffffff" v-if="item.list">
            <el-timeline-item
              v-for="(activity, index) in item.list"
              :key="index"
              color="#0649B2"
            >
              <p style="color: #ffffff;">{{ activity.day }}</p>
              <p style="color: #ffffff;font-size: 12px;margin: 5px 0 0 5px">
                {{ activity.workArea }}
              </p>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>
    <span :class="[this.side == true ? 'openspan' : 'closespan']" @click="colse"
      ><img
        src="../../../static/img/Arrow.png"
        style="width:23px;min-height:40px;"
    /></span>
    <div :class="[this.side == true ? 'colseGogle' : 'Gogle']">
      <div id="container" style="width: 100%;height: 80vh;"></div>
    </div>
  </div>
</template>

<script>
/*import Gmap from '../../map/js/GoogleHelper.js'*/
import Gmap from "../../map/js/fzTianmap.js";
import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
import TalksMap from "../../map/js/initMapTalks.js";
export default {
  name: "TLocalRecord",
  data() {
    return {
      center: { lng: 116.4, lat: 39.9 },
      Gmap: new Gmap(),
      TalksMapDialog: new TalksMap(),
      map: "",
      Local: "", //历史轨迹
      side: true,
      sidetex: "隐藏",
      tableData: [],
      imei: "", //设备编号
      getkey: "",
      listyear: [], //年份列表
      Title: "", //农机名称
      //时间轴
      activities: [
        {
          content: "",
          timestamp: "04-03"
          /* color: '#0649B2'*/
        }
      ],
      lastRequestData: []
    };
  },
  mounted() {
    this.intMap();
    this.tabledata();
  },
  methods: {
    intMap() {
      this.TalksMapDialog.init("container", 12);
      this.TalksMapDialog.map.setMinZoom(3);
      this.Record();
    },
    goBack() {
      var manage = JSON.parse(sessionStorage.getItem("manageParam"));
      sessionStorage.setItem("manageParams", JSON.stringify(manage));
      this.Info.Info.imei = this.$route.params.imei;
      this.Info.Info.stat_time = this.$route.params.stat_time;
      this.$router.go(-1);
    },
    //轨迹坐标
    Record() {
      this.imei = this.$route.params.imei
        ? this.$route.params.imei
        : this.$store.state.imei;
      var url = Http.test + "/common/listHistoryCoord";
      var parmse = {
        // imei: this.imei,
        imei: this.$route.params.qrNumber?undefined:this.imei,
        qrNumber: this.$route.params.qrNumber?this.$route.params.qrNumber:undefined,
      };
      Api.doPost(
        url,
        parmse,
        false,
        res => {
          this.Local = res.result.listHistoryCoord;
          var List = res.result.listHistoryCoord;
          this.Title = res.result.njName;
          this.trackList = res.result.listHistoryCoord;
          this.lineArr = List;
          if (this.lngLatCenter) {
            this.TalksMapDialog.map.setCenter(this.lngLatCenter);
          } else {
            let Coordinate = {
              x: Number(List[0].lng),
              y: Number(List[0].lat)
            };
            this.TalksMapDialog.map.setCenter(Coordinate);
          }
          this.TalksMapDialog.addMark(List, true, true);
          this.TalksMapDialog.drawLine(List);
        },
        function(err) {}
      );
    },
    //table数据
    tabledata() {
      var url = Http.test + "/common/listHistoryTrack";
      this.imei = this.$route.params.imei
        ? this.$route.params.imei
        : this.$store.state.imei;
      var parmse = {
        // imei: this.imei
        imei: this.$route.params.qrNumber?undefined:this.imei,
        qrNumber: this.$route.params.qrNumber?this.$route.params.qrNumber:undefined,
      };
      Api.doPost(
        url,
        parmse,
        false,
        res => {
          this.tableData = res.result.dataSource;
        },
        err => {}
      );
    },
    //关闭侧边栏
    colse() {
      this.side = !this.side;
    }
  }
}
</script>

<style scoped>
.el-timeline-item__tail {
  border-left: 1px solid #e4e7ed !important;
}
.top-block {
  width: 98%;
  margin: 0 auto;
  background-color: #0b1640;
  height: 87vh;
  overflow: hidden;
}
.top-tit {
  padding: 0;
  margin-left: 25px;
  display: inline-block;
  font-weight: bold;
  font-size: 18px;
  line-height: 60px;
  color: #ccc;
}
.blue-border {
  display: inline-block;
  width: 5px;
  height: 20px;
  position: relative;
  top: 3px;
  background-color: #297af5;
  left: 20px;
}
#control {
  width: 70%;
  display: flex;
  justify-content: space-between;
}
.side {
  width: 14%;
  height: 87vh;
  color: #ffffff;
  float: left;
  z-index: 666;
  overflow: auto;
}
.happy-scroll-container {
  height: unset !important;
}
.openspan {
  display: inline-block;
  width: 30px;
  height: 30px;
  float: left;
  position: absolute;
  left: calc(14% + 28px);
  top: calc(50% + 46px);
  z-index: 9999;
}
.closespan {
  display: inline-block;
  width: 30px;
  height: 30px;
  position: absolute;
  left: 40px;
  top: 420px;
  z-index: 9999;
}
.Gogle {
  height: calc(100vh - 181px);
  width: 100%;
  margin-bottom: 20px;
  margin-top: 5px;
  float: left;
}
.colseGogle {
  height: calc(100vh - 181px);
  width: 86%;
  float: left;
  margin-bottom: 20px;
  margin-top: 5px;
  float: left;
}
.allText {
  margin: 15px;
}
.allSize {
  font-size: 18px;
}
.testStyle {
  padding: 5px 15px;
}
.details-ret {
  display: inline-block;
}
.details-ret span {
  display: inline-block;
  margin-left: 5px;
  font-size: 14px;
  font-weight: unset;
  color: #f45a2b;
}
.ret {
  font-size: 22px;
  font-weight: bold;
  color: #75c3ff;
  display: inline-block;
}
.hiden {
  width: 100%;
  height: 100%;
  background: #0b1640 !important;
}
/*滚动条样式*/
/*!*滚动条整体部分,必须要设置*!*/
.side::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #08172e;
}
/*!*滚动条的轨道*!*/
.side::-webkit-scrollbar-track {
  background-color: #0b1640;
}
/*!*滚动条的滑块按钮*!*/
.side::-webkit-scrollbar-thumb {
  border-radius: 3px;
  height: 5px;
  background-color: rgba(255, 255, 255, 0.7);
}
/*!*滚动条的上下两端的按钮*!*/
.side::-webkit-scrollbar-button {
  height: 10px;
  background-color: #08172e;
}

/*  div{width: 200px;height: 200px;overflow: auto;padding: 20px;}*/
</style>



// WEBPACK FOOTER //
// src/components/Local/TLocalRecord.vue